import { StuckLoadingRecovery } from '@/components/StuckLoadingRecovery';
import { useStuckLoadingTimeout } from '@/hooks/useStuckLoadingTimeout';
import { STAGE_LABELS, type AppLoadingStage } from '@/lib/loadingMessages';
import React, { useEffect, useState } from 'react';
import { LOADING_SPINNER_COLOR } from '@/lib/loadingSpinnerColor';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';

const SHOW_DELAY_MS = __DEV__ ? 0 : 350;

type Props = {
  stage?: AppLoadingStage;
  delay?: number;
};

export function AppLoadingScreen({ stage, delay = SHOW_DELAY_MS }: Props) {
  const stageLabel = stage ? STAGE_LABELS[stage] : undefined;
  const [visible, setVisible] = useState(delay === 0);
  const stuck = useStuckLoadingTimeout();

  useEffect(() => {
    if (delay === 0) return;
    const timer = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  if (stuck) return <StuckLoadingRecovery />;
  if (!visible) return null;

  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color={LOADING_SPINNER_COLOR} />
      {stageLabel && <Text style={styles.stage}>{stageLabel}</Text>}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    paddingHorizontal: 32,
  },
  stage: {
    marginTop: 20,
    fontSize: 15,
    fontWeight: '600',
    color: '#444',
    textAlign: 'center',
  },
});
